/* eslint-disable react-hooks/exhaustive-deps */
import { Tab } from '@scuf/common';
import { useTranslation } from 'react-i18next';
import 'styles/main.scss';
import 'styles/repaircenter.scss';
import { RmaReport, RmaSearch } from './components';
import useUser from 'helpers/hooks/useUser';
import { useEffect, useState } from 'react';
import { WelcomeMessageScreens } from 'models';
import useFetch from 'helpers/hooks/useFetch';
import { ManualFile } from 'pages/manual/acordion/messageTable';
import { USER_MANAGER } from 'resources';
import i18n from 'i18n';

function RepairCenter() {
    const { user } = useUser();
    const section = "msg-manufatura";
    const { t } = useTranslation(['rmamanufatura', 'common']);
    const [show, setShow] = useState(false);
    const { user: userDetails, getUser } = useUser();
    const [fileUrl, setFileUrl] = useState<string>();
    const [, fetchFiles] = useFetch<void, ManualFile>({
        url: `${USER_MANAGER.getIdPortalMensagem}?section=${section}&language=${i18n.language}`,
        method: 'GET'
    });

    useEffect(() => {
        if (userDetails && Object.keys(userDetails).length > 0) {
            loadFiles();
        }
    }, [userDetails]);

    const hasRelatorio = () => {
        const hasRelatorio = !!(user?.role === '1' || user?.role === '2');

        return hasRelatorio;
    };

    const tabRelatorio = [
        hasRelatorio() ? (
            <Tab.Pane title={t('RELATÓRIOS')}>
                <RmaReport />
            </Tab.Pane>
        ) : null
    ].filter(Boolean);

    const [hasSeenMessage, setHasSeenMessage] = useState(() => {
        const storedValue = sessionStorage.getItem('welcomeMessageSeen');
        try {
            if (storedValue) {
                const welcomeMessageSeen: WelcomeMessageScreens =
                    JSON.parse(storedValue);

                return welcomeMessageSeen.manufatura === true;
            }
        } catch {
            return false;
        }
    });

    const loadFiles = async (): Promise<void> => {
        try {
            if (hasSeenMessage === true) {
                return;
            }
            await fetchFiles(undefined, (resp) => {
                const { id } = resp.data ?? {};
                if (!id) {
                    return;
                }
                setFileUrl(`${USER_MANAGER.downloadManualFileById}?id=${id}`);
                setShow(true);
            });
        } catch (error: any) {
            if (error.status === 401) {
                await getUser();
            } else {
                console.error(t('manual.fetchFilesError'));
            }
        }
    };

    function handleMessage() {
        const storedValue = sessionStorage.getItem('welcomeMessageSeen');

        const welcomeMessageSeen = storedValue
            ? JSON.parse(storedValue)
            : {
                homepage: false,
                repair: false,
                spare: false,
                manufatura: false,
                hsl: false,
            };

        sessionStorage.setItem(
            'welcomeMessageSeen',
            JSON.stringify({
                ...welcomeMessageSeen,
                manufatura: true
            })
        );
        setHasSeenMessage(true);
        setShow(false);
    }

    return (
        <>
            {show && userDetails && Object.keys(userDetails).length > 0 && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}
                    onClick={() => handleMessage()}
                >
                    <img
                        style={{ maxWidth: '800px', maxHeight: '800px' }}
                        src={fileUrl}
                        onClick={e => e.stopPropagation()}
                        title="Mensagem Portal"
                    />
                </div>
            )}
            <div className="container">
                <Tab defaultActiveIndex={0} className="tab-with-divider">
                    <Tab.Pane title={t('RMA')}>
                        <RmaSearch />
                    </Tab.Pane>
                    {tabRelatorio}
                </Tab>
            </div>
        </>
    );
}

export default RepairCenter;
